var SupportBasePresentation, SupportPresenterUtilPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportPresenterUtilPresentation = require('./presenter_util');

SupportBasePresentation = (function() {
  function SupportBasePresentation(order) {
    this.order = order;
  }

  SupportBasePresentation.prototype.getStatus = function() {
    var keyPrefix, value;
    keyPrefix = this.getLookupKeySequence();
    value = SupportPresenterUtilPresentation.prototype.lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation.prototype.STATUS);
    if (value == null) {
      value = this.convertToReadableText(this.order.STATE);
    }
    return value;
  };

  SupportBasePresentation.prototype.getNotes = function() {
    var keyPrefix, value;
    keyPrefix = this.getLookupKeySequence();
    value = SupportPresenterUtilPresentation.prototype.lookup(this.getLookupObject(), keyPrefix, SupportPresenterUtilPresentation.prototype.NOTES);
    if (value == null) {
      value = '';
    }
    return value;
  };

  SupportBasePresentation.prototype.getLookupKeySequence = function() {
    var keys;
    if (this.order != null) {
      keys = [];
      if (this.canShowGiftInfo()) {
        keys.push(SupportPresenterUtilPresentation.prototype.getGiftDeliveryMethod(this.order));
      } else if (this.isGDTOrder()) {
        keys = SupportPresenterUtilPresentation.prototype.getGDTKeys(this.order);
      } else {
        keys.push(SupportPresenterUtilPresentation.prototype.getEditableKey(this.order.isEditable));
        keys.push(SupportPresenterUtilPresentation.prototype.getStatusKey(this.order));
      }
      return SupportPresenterUtilPresentation.prototype.concatenateLookupKeys(keys);
    }
  };

  SupportBasePresentation.prototype.getLookupObject = function() {
    return console.log("No implementation");
  };

  SupportBasePresentation.prototype.canShowGiftInfo = function() {
    return this.isGift(this.order) && (SupportPresenterUtilPresentation.prototype.getStatusKey(this.order) !== 'REFUNDED') && (!SupportUtilsHelper.isCurrentOrderGoodsDeal());
  };

  SupportBasePresentation.prototype.isGift = function() {
    return this.order.isGift && this.order.giftInfo;
  };

  SupportBasePresentation.prototype.isGDTOrder = function() {
    var ref;
    return SupportUtilsHelper.isCurrentOrderLocalDeal() && window.evaluate((ref = this.order.deal) != null ? ref.isGDTDeal : void 0);
  };

  SupportBasePresentation.prototype.convertToReadableText = function(value) {
    var i, len, lowercase, piece, pieces, words;
    if (!!value) {
      lowercase = value.toLowerCase();
      pieces = lowercase.split("_");
      words = [];
      for (i = 0, len = pieces.length; i < len; i++) {
        piece = pieces[i];
        if (!!piece) {
          words.push(piece.charAt(0).toUpperCase() + piece.slice(1));
        }
      }
      if (words.length > 1) {
        return words.join(" ");
      } else {
        return words[0];
      }
    }
  };

  return SupportBasePresentation;

})();

module.exports = SupportBasePresentation;

//# sourceMappingURL=data:application/json;base64,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
